import { useState } from "react"
import {roman} from "../../../../data/roman"
import ListSelect from "../../ListSelect"
import Btn from "../../Btn"

const Roman = (props) => {

    const selectList = roman.map(rom => ({
        id:rom.id,
        name:rom.name,
        wood:rom.wood,
        clay:rom.clay,
        iron:rom.iron,
        crop:rom.crop,
        all: rom.wood + rom.clay + rom.crop + rom.iron
    }) )

    const [selectValue, setSelectValue] = useState("")
    const handleSelectValue = event => {
        setSelectValue(event.target.value)
    }

    function vypis() {
        const selectedRoman = selectList[selectValue-1]
        props.addItem(selectedRoman)
    }

return (
    <div>
        <ListSelect label="...choose trop..." selectList={selectList} handleSelectValue={handleSelectValue} />
        {selectValue ? (
            <Btn className="btn" type="submit" text="Add to result" onClick={vypis} />
        ) : null}
    </div>
    )
}
export default Roman
